module.exports = __webpack_public_path__ + "img/img-7.037df1b4.svg";